import {Avatar, IconButton} from '@mui/material';

export interface NavBarMobileMenuButtonProps {
  handleMobileMenuToggle: () => void;
  photoUrl?: string;
  displayName: string;
}

export default function NavBarMobileMenuButton({
  handleMobileMenuToggle,
  photoUrl,
  displayName,
}: NavBarMobileMenuButtonProps) {
  return (
    <IconButton
      data-testid="navbar-mobile-menu-button"
      color="inherit"
      aria-label="open mobile menu"
      onClick={handleMobileMenuToggle}
      sx={{
        color: 'text.primary',
        '&:hover': {
          backgroundColor: 'grey.100',
        },
      }}
    >
      <Avatar
        sx={{
          width: 32,
          height: 32,
          bgcolor: 'secondary.main',
          color: 'white',
        }}
        src={photoUrl}
      >
        {displayName[0]?.toUpperCase() || 'U'}
      </Avatar>
    </IconButton>
  );
}
